export default "__VITE_ASSET__xLmV1J3R__"